"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importDefault(require("react"));

var theme_1 = require("../../styles/theme");

var H_1 = require("./H");

var ContentBlock = styled_1["default"]('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .-h {\n    margin-bottom: 0;\n  }\n  .-icon-container,\n  .-body-container {\n    line-height: ", "px;\n  }\n"], ["\n  .-h {\n    margin-bottom: 0;\n  }\n  .-icon-container,\n  .-body-container {\n    line-height: ", "px;\n  }\n"])), theme_1.theme.spacing.standard);

var hasHeaderSection = function hasHeaderSection(props) {
  return "h1,h2,h3,h4,h5,h6,subtitle,title".split(',').map(function (key) {
    return props[key];
  }).some(function (prop) {
    return Boolean(prop);
  });
};

var hasBodySection = function hasBodySection(props) {
  return Boolean(props.copy || props.cta) || hasHeaderSection(props);
};

var renderStringProperty = function renderStringProperty(prop) {
  var arr = Array.isArray(prop) ? prop : [prop];
  return arr.map(function (val, i) {
    return react_1["default"].createElement("div", {
      key: "p-" + i
    }, val);
  });
};

exports["default"] = function (props) {
  return react_1["default"].createElement(ContentBlock, __assign({}, props), props.icon && react_1["default"].createElement("div", {
    className: '-icon-container'
  }, props.icon), hasBodySection(props) && react_1["default"].createElement("div", {
    className: '-body-container'
  }, hasHeaderSection(props) && react_1["default"].createElement(react_1["default"].Fragment, null, props.h1 && react_1["default"].createElement(H_1.H1, {
    className: '-h -h1'
  }, props.h1), props.h2 && react_1["default"].createElement(H_1.H2, {
    className: '-h -h2'
  }, props.h2), props.h3 && react_1["default"].createElement(H_1.H3, {
    className: '-h -h3'
  }, props.h3), props.h4 && react_1["default"].createElement(H_1.H4, {
    className: '-h -h4'
  }, props.h4), props.h5 && react_1["default"].createElement(H_1.H5, {
    className: '-h -h5'
  }, props.h5), props.h6 && react_1["default"].createElement(H_1.H6, {
    className: '-h -h6'
  }, props.h6), props.title && react_1["default"].createElement(H_1.H3, {
    className: '-title'
  }, props.title), props.subtitle && react_1["default"].createElement(H_1.H4, {
    className: '-subtitle'
  }, props.subtitle)), props.copy && react_1["default"].createElement("div", {
    className: '-copy-container'
  }, renderStringProperty(props.copy)), props.cta && react_1["default"].createElement("div", {
    className: '-cta-container'
  }, props.cta)));
};

var templateObject_1;